import { BaseService } from './Base.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { ApiResponse, TenantDto, TenantUserDto, TenantSearchDto } from '../models';

@Injectable({
  providedIn: 'root',
})
export class TenantUserService extends BaseService<TenantUserDto> {
  private tenantUserUrl = `${environment.apiUrl}/Tenants`;

  constructor(http: HttpClient) {
    super(http);
    this.apiUrl = this.tenantUserUrl;
  }

  getTenantUsers(
    tenantUserSearchDto: TenantSearchDto
  ): Observable<ApiResponse<TenantUserDto[]>> {
    const headers = this.getHeaders();
    return this.http.post<ApiResponse<TenantUserDto[]>>(
      `${this.apiUrl}/ListAll`,
      tenantUserSearchDto,
      {
        headers,
      }
    );
  }

  /** Tenants/GetByID returns the bare tenant (not the tenant+admin pair). */
  getTenantById(id: string): Observable<ApiResponse<TenantDto>> {
    return this.http.get<ApiResponse<TenantDto>>(`${this.apiUrl}/GetByID/${id}`, {
      headers: this.getHeaders(),
    });
  }

  getTenantUserById(id: string): Observable<ApiResponse<TenantUserDto>> {
    return this.getById(id);
  }

  addTenantUser(
    tenantUser: any
  ): Observable<ApiResponse<TenantUserDto>> {
    return this.create('Create', tenantUser);
  }

  updateTenantUser(
    id: string,
    tenantUser: any
  ): Observable<ApiResponse<TenantUserDto>> {
    return this.http.put<ApiResponse<TenantUserDto>>(
      `${this.apiUrl}/Update/${id}`,
      tenantUser,
      { headers: this.getHeaders() }
    );
  }

  deleteTenantUser(id: string): Observable<ApiResponse<void>> {
    return this.delete('Delete', id);
  }
}
